export default "__VITE_ASSET__E22JXnwx__"